export default "__VITE_ASSET__SKPCVm6o__"